
<div class="orders-page">

  <!-- HEADER -->
  <div class="orders-header">
    <div class="orders-header__title">
      <span class="orders-header__icon">
        <mat-icon>assignment</mat-icon>
      </span>

      <div>
        <h1 id="lista"
            [translation]="TranslationEnum.Translation"
            *ngIf="!Valuation">
          {{ 'lista' | translate }}
        </h1>

        <h1 id="listawycen"
            [translation]="TranslationEnum.Translation"
            *ngIf="Valuation">
          {{ 'listawycen' | translate }}
        </h1>

        <div class="orders-header__subtitle">
          {{ Valuation ? 'Wyceny' : 'Zamówienia' }}
        </div>
      </div>
    </div>
  </div>


  <!-- FILTERS -->
  <div class="orders-filters">

    <div class="orders-filters__title">
      <mat-icon>tune</mat-icon>
      <span>Filtry</span>
    </div>

    <div class="orders-filters__options">

      <mat-checkbox
        color="primary"
        class="orders-checkbox valuation_{{ Valuation }} pokaz_{{ pokazWszystkieZam }}"
        #isMineOrders
        [(ngModel)]="IsMineOrders"
        (change)="refresh()">

        <span
          id="czymojezam"
          class="pokaz_{{ pokazWszystkieZam }}"
          [translation]="TranslationEnum.Translation">
          {{ 'czymojezam' | translate }}
        </span>

      </mat-checkbox>


      <mat-checkbox
        *ngIf="Valuation && (IsTrader || CreateComplaintOrder)"
        color="primary"
        class="orders-checkbox valuation_{{ Valuation }}"
        [(ngModel)]="ShowComplaints"
        (change)="refresh()">

        <span
          id="czyreklamacja"
          [translation]="TranslationEnum.Translation">
          {{ 'czyreklamacja' | translate }}
        </span>

      </mat-checkbox>

    </div>
  </div>


  <!-- STATUS TABS -->
  <div class="orders-tabs-wrapper">

    <mat-tab-group
      [selectedIndex]="selected_id"
      animationDuration="0ms"
      class="orders-tabs valuationtab_{{ Valuation }}">

      <!-- OPRACOWYWANE -->
      <mat-tab *ngIf="!BlockingB2B" label="First">

        <ng-template mat-tab-label>
          <span class="order-tab-label">
            <span
              id="opracowywane"
              [translation]="TranslationEnum.Translation">
              {{ 'opracowywane' | translate }}
            </span>

            <span
              class="order-tab-count"
              *ngIf="StatuesQuantity.Opracowywane !== 0">
              {{ StatuesQuantity.Opracowywane }}
            </span>
          </span>
        </ng-template>

        <ng-template matTabContent>
          <app-order-list
            [status]="+StatusEnum.Opracowywane"
            [refresh]="refreshRegister"
            [IsSaleBlocked]="IsSaleBlocked"
            [isMineOrders]="isMineOrders.checked"
            [ShowComplaints]="ShowComplaints"
            [dateFrom]="dateFrom"
            [dateTo]="dateTo">
          </app-order-list>
        </ng-template>

      </mat-tab>


      <!-- PRZEKAZANE -->
      <mat-tab
        *ngIf="!BlockingB2B && StatuesQuantity.Przekazane > 0"
        label="Przekazano">

        <ng-template mat-tab-label>
          <span class="order-tab-label">
            <span
              id="przekazane"
              [translation]="TranslationEnum.Translation">
              {{ 'przekazane' | translate }}
            </span>

            <span
              class="order-tab-count"
              *ngIf="StatuesQuantity.Przekazane !== 0">
              {{ StatuesQuantity.Przekazane }}
            </span>
          </span>
        </ng-template>

        <ng-template matTabContent>
          <app-order-list
            [status]="+StatusEnum.Przekazane"
            [refresh]="refreshRegister"
            [IsSaleBlocked]="IsSaleBlocked"
            [isMineOrders]="isMineOrders.checked"
            [ShowComplaints]="ShowComplaints"
            [dateFrom]="dateFrom"
            [dateTo]="dateTo">
          </app-order-list>
        </ng-template>

      </mat-tab>


      <!-- ZAMÓWIONO -->
      <mat-tab
        *ngIf="!BlockingB2B && !Valuation"
        label="zamowiono">

        <ng-template mat-tab-label>
          <span class="order-tab-label">
            <span
              id="zamowiono"
              [translation]="TranslationEnum.Translation">
              {{ 'zamowiono' | translate }}
            </span>

            <span
              class="order-tab-count"
              *ngIf="StatuesQuantity.Zamowiono !== 0">
              {{ StatuesQuantity.Zamowiono }}
            </span>
          </span>
        </ng-template>

        <ng-template matTabContent>
          <app-order-list
            [status]="+StatusEnum.Zamowiono"
            [refresh]="refreshRegister"
            [isMineOrders]="isMineOrders.checked"
            [ShowComplaints]="ShowComplaints"
            [IsSaleBlocked]="IsSaleBlocked"
            [dateFrom]="dateFrom"
            [dateTo]="dateTo">
          </app-order-list>
        </ng-template>

      </mat-tab>


      <!-- REALIZACJA -->
      <mat-tab
        *ngIf="!BlockingB2B && !Valuation"
        label="realizacja">

        <ng-template mat-tab-label>
          <span class="order-tab-label">
            <span
              id="realizacja"
              [translation]="TranslationEnum.Translation">
              {{ 'realizacja' | translate }}
            </span>

            <span
              class="order-tab-count"
              *ngIf="StatuesQuantity.Realizacja !== 0">
              {{ StatuesQuantity.Realizacja }}
            </span>
          </span>
        </ng-template>

        <ng-template matTabContent>
          <app-order-list
            [status]="+StatusEnum.Realizacja"
            [refresh]="refreshRegister"
            [IsSaleBlocked]="IsSaleBlocked"
            [isMineOrders]="isMineOrders.checked"
            [ShowComplaints]="ShowComplaints"
            [dateFrom]="dateFrom"
            [dateTo]="dateTo">
          </app-order-list>
        </ng-template>

      </mat-tab>


      <!-- WSTRZYMANO -->
      <mat-tab
        *ngIf="!BlockingB2B && !Valuation"
        label="wstrzymano">

        <ng-template mat-tab-label>
          <span class="order-tab-label">
            <span
              id="wstrzymano"
              [translation]="TranslationEnum.Translation">
              {{ 'wstrzymano' | translate }}
            </span>

            <span
              class="order-tab-count"
              *ngIf="StatuesQuantity.Wstrzymano !== 0">
              {{ StatuesQuantity.Wstrzymano }}
            </span>
          </span>
        </ng-template>

        <ng-template matTabContent>
          <app-order-list
            [status]="+StatusEnum.Wstrzymano"
            [refresh]="refreshRegister"
            [IsSaleBlocked]="IsSaleBlocked"
            [isMineOrders]="isMineOrders.checked"
            [ShowComplaints]="ShowComplaints"
            [dateFrom]="dateFrom"
            [dateTo]="dateTo">
          </app-order-list>
        </ng-template>

      </mat-tab>


      <!-- ZAKOŃCZONO -->
      <mat-tab
        *ngIf="!BlockingB2B && !Valuation"
        label="zakonczono">

        <ng-template mat-tab-label>
          <span class="order-tab-label">
            <span
              id="zakonczono"
              [translation]="TranslationEnum.Translation">
              {{ 'zakonczono' | translate }}
            </span>

            <span
              class="order-tab-count"
              *ngIf="StatuesQuantity.Zakonczono !== 0">
              {{ StatuesQuantity.Zakonczono }}
            </span>
          </span>
        </ng-template>

        <ng-template matTabContent>
          <app-order-list
            [status]="+StatusEnum.Zakonczono"
            [refresh]="refreshRegister"
            [IsSaleBlocked]="IsSaleBlocked"
            [isMineOrders]="isMineOrders.checked"
            [ShowComplaints]="ShowComplaints"
            [dateFrom]="dateFrom"
            [dateTo]="dateTo">
          </app-order-list>
        </ng-template>

      </mat-tab>


      <!-- ANULOWANO -->
      <mat-tab
        *ngIf="!BlockingB2B && !Valuation"
        label="anulowano">

        <ng-template mat-tab-label>
          <span class="order-tab-label">
            <span
              id="anulowano"
              [translation]="TranslationEnum.Translation">
              {{ 'anulowano' | translate }}
            </span>

            <span
              class="order-tab-count"
              *ngIf="StatuesQuantity.Anulowano !== 0">
              {{ StatuesQuantity.Anulowano }}
            </span>
          </span>
        </ng-template>

        <ng-template matTabContent>
          <app-order-list
            [status]="+StatusEnum.Anulowano"
            [refresh]="refreshRegister"
            [isMineOrders]="isMineOrders.checked"
            [ShowComplaints]="ShowComplaints"
            [IsSaleBlocked]="IsSaleBlocked"
            [dateFrom]="dateFrom"
            [dateTo]="dateTo">
          </app-order-list>
        </ng-template>

      </mat-tab>


      <!-- PŁATNOŚCI -->
      <mat-tab
        *ngIf="canOrder && !BlockingB2B && !Valuation"
        label="platnosci">

        <ng-template mat-tab-label>
          <span class="order-tab-label">
            <span
              id="platnosci"
              [translation]="TranslationEnum.Translation">
              {{ 'platnosci' | translate }}
            </span>

            <span
              class="order-tab-count"
              *ngIf="StatuesQuantity.Platnosci !== 0">
              {{ StatuesQuantity.Platnosci }}
            </span>
          </span>
        </ng-template>

        <ng-template matTabContent>
          <app-proforms-list
            [isMineOrders]="isMineOrders.checked"
            [dateFrom]="dateFrom"
            [dateTo]="dateTo"
            [refresh]="refreshRegister">
          </app-proforms-list>
        </ng-template>

      </mat-tab>

    </mat-tab-group>

  </div>

</div>

